import { IReduxStore } from "./reducers"

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("safco__adm")
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}
export const saveState = (state: IReduxStore) => {
  try {
    const { account } = state
    const serializedState = JSON.stringify({ account })
    localStorage.setItem("safco__adm", serializedState)
  } catch (e) {} //eslint-disable-line
}
